export function nameInitial(value) {
  return String(value).trim().charAt(0).toUpperCase()
}
